import { Checkbox } from "@bookdental/ui";
import { useLinkDoCatalogo } from "@/components/catalogo/publico/use-link-do-catalogo";

/** "QR do catálogo" das etiquetas que vão até o dentista. Sem o catálogo público ligado não há o
 *  que abrir — a opção fica travada e diz onde ligar. */
export function OpcaoQrDoCatalogo({ checked, onChange, onde }: { checked: boolean; onChange: (v: boolean) => void; onde: string }) {
  const link = useLinkDoCatalogo();
  return (
    <label className="flex items-start gap-2 text-sm text-zinc-700 dark:text-foreground">
      <Checkbox checked={checked && !!link} disabled={!link} onCheckedChange={(v) => onChange(v === true)} className="mt-0.5" />
      <span className={link ? undefined : "text-zinc-400 dark:text-muted-foreground"}>
        QR do catálogo {onde}
        <span className="block text-xs text-zinc-500 dark:text-muted-foreground">
          {link
            ? "Lido com o celular, abre o catálogo público do laboratório (sem login)."
            : "Ligue o catálogo público em Configurações › Perfil público para usar."}
        </span>
      </span>
    </label>
  );
}
